<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('请输入会员帐号') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.code' :placeholder="$t('请输入邀请码') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.is_activity' clearable
                                                      :placeholder="$t('邀请码类型') " style='width:120px'>
              <Option :value="'0'">{{ $t('无赠送') }}</Option>
              <Option :value="'1'">{{ $t('注册赠送') }}</Option>
            </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'activityManage/activityInvitationCode/add'" @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="120"
            label-position="left">
        <FormItem label='用户名' prop='username'>
          <Input v-model='windowAddItem.username' :placeholder="$t('请输入用户名')" :disabled="windowAddItem.id"></Input>
        </FormItem>
        <FormItem label='邀请码' prop='code'>
          <Input v-model='windowAddItem.code' :placeholder="$t('请输入邀请码')" :disabled="windowAddItem.id"></Input>
        </FormItem>
        <FormItem label='邀请类别' prop='user_type'>
          <Select v-model='windowAddItem.user_type' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('会员') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('代理') }}</Option>
          </Select>
        </FormItem>
        <FormItem label='是否注册赠送' prop='is_activity'>
          <Select v-model='windowAddItem.is_activity' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('不启用') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('启用注册赠送') }}</Option>
          </Select>
        </FormItem>
        <FormItem label='注册赠送金额' prop='activity_send_money' v-if="this.windowAddItem.is_activity=='1'">
          <Input v-model='windowAddItem.activity_send_money' :placeholder="$t('请输入注册赠送金额')"></Input>
        </FormItem>
        <FormItem label='备注' prop='remark'>
          <Input v-model='windowAddItem.remark' :placeholder="$t('请输入备注')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  getWindowsParams
} from '@/api/activityManage/activityInvitationCode'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('所属会员'),
        key: 'username',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('邀请码'),
        key: 'code',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('邀请类别'),
        key: 'user_type_name',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('累计注册'),
        key: 'user_count',
        sortable: 'custom',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('赠送人数'),
        key: 'activity_reg_num',
        sortable: 'custom',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('注册赠送金额'),
        key: 'activity_send_money',
        sortable: 'custom',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('累计赠送'),
        key: 'activity_total_send',
        sortable: 'custom',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('备注'),
        key: 'remark',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('注册赠送'),
        align: 'center',
        minWidth: 100,

        key: 'is_activity',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.is_activity ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.is_activity ? '1px solid #ed4014' : '1px solid #19be6b',
                display: 'block',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                margin: 'auto'
              },
            }, params.row.is_activity ? this.$t('赠送') : this.$t('不赠送')),
          ])
        }
      }, {
        title: this.$t('状态'),
        align: 'center',
        minWidth: 100,

        key: 'is_delete',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.is_delete ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.is_delete ? '1px solid #ed4014' : '1px solid #19be6b',
                display: 'block',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                margin: 'auto'
              },
            }, params.row.is_delete ? this.$t('已隐藏') : this.$t('正常')),
          ])
        }
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAddItem.id = params.row.id
                vm.windowAddItem.user_type = params.row.user_type.toString()
                vm.windowAddItem.is_activity = params.row.is_activity.toString()
                vm.windowAddItem.username = params.row.username
                vm.windowAddItem.code = params.row.code
                vm.windowAddItem.remark = params.row.remark
                vm.windowAddItem.activity_send_money = params.row.activity_send_money
                vm.windowAdd.show = true
              }
            }
          }, this.$t('修改')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('确定要隐藏本条私信?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                del(params.row.id).then(response => {
                  this.$Message.success(response.data.msg)
                  this.getList()
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('info'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('隐藏'))
          ]),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        is_activity: '',
        activity_send_money: ''
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('activityManage/activityInvitationCode/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('activityManage/activityInvitationCode/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('activityManage/activityInvitationCode/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted () {
    this.getWindowsParams()
  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowAddItem = { is_activity: '' }
      vm.windowAddItem.user_type = '0'
      vm.windowAddItem.is_activity = '0'
      vm.windowAdd.show = true
    },
    getWindowsParams () {
      // getWindowsParams().then(response => {
      //     this.windowAdd.windowsParams = response.data.data
      // })
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          add(vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
